import React from "react";
import {TransfersDataType} from "@SearchResults/features/banners/features/getByTransferBanner/types/TransfersData.type";
import VehicleSnippets from "@/features/getByTransfer/features/snippets/components/VehicleSnippets";
import useDefaultVehicleSnippets from "@/features/getByTransfer/features/snippets/hooks/useDefaultVehicleSnippets";

interface GetByTransferSearchResultsBannerProps {
    transfersData: TransfersDataType,
    snippetsAdditionalClassName?: string,
}

function GetByTransferSearchResultsBanner(props: GetByTransferSearchResultsBannerProps) {
    const defaultVehicleSnippets = useDefaultVehicleSnippets();

    const {
        transfersData,
        snippetsAdditionalClassName = "",
    } = props

    const {
        vehicles,
    } = transfersData || {}

    return (
        <VehicleSnippets
            vehicles={vehicles || defaultVehicleSnippets}
            additionalClassName={snippetsAdditionalClassName}
        />
    )
}

export default GetByTransferSearchResultsBanner